import { CurveMath } from "@alchemiesolns/kaff-arrow";
import { CurveProps } from "@alchemiesolns/kaff-arrow/src/types";
import { getFormat } from "./utils/formatContext";
import { ArrowConfigDef, ArrowDef } from "@alchemiesolns/arrow-def";


export const svgPaperArrows = {
    drawArrowTube: (arrows: CurveProps[], arrowDefs: ArrowConfigDef[]) => {
        return arrows.map((arr, index) => {
            const c = 1
            const curve = CurveMath.calculatePoints(arr);
            const controlPoint1 = { x: curve.cp1[0], y: curve.cp1[1]};
            const controlPoint2 = { x: curve.cp2[0], y: curve.cp2[1]};
            const d = `M ${curve.start[0]}, ${curve.start[1]} C ${controlPoint1.x*c}, ${controlPoint1.y*c} ${controlPoint2.x*c}, ${controlPoint2.y*c} ${curve.end[0]}, ${curve.end[1]}`;

            // Use encoded arrow string as key
            const arrowKey = arrowDefs[index] ? ArrowDef.encodeDef(arrowDefs[index]) : `arrow-${index}`;
            const arrowDef = arrowDefs[index];

            return (
                <g
                    key={arrowKey}
                    data-arrow-index={index}
                    data-arrow-type={arrowDef?.type}
                    data-arrow-src={arrowDef?.src}
                    data-arrow-dst={arrowDef?.dst}
                    data-arrow-p={arrowDef?.p}
                >
                    {/* <circle cx={controlPoint1.x*c} cy={controlPoint1.y*c} r={.3} fill={"red"} opacity={.6}/>
                    <circle cx={controlPoint2.x*c} cy={controlPoint2.y*c} r={.3} fill={"green"} opacity={.6}/> */}
                    <path d={d} stroke={"#BE0000"} fillOpacity={0} strokeWidth={getFormat().arrow.thickness} markerEnd={arr.type === "curve" ? "url(#arrowhead)" : curve.head.side ? "url(#fishheadleft)" : "url(#fishheadright)"}/>
                </g>
        )})

    }
}